import React from 'react';
import Icon from './Icon';

import {Col, Nav} from 'react-bootstrap';
import styles from './css/AppLink.module.css';

const AppLink = props => {
	return (
		<Col xs={4}>
			<Nav.Link
				className="p-0 text-center"
				href={props.link}
				onClick={event => props.onClick(event, props.link, props.newTab)}
			>
				<Icon colorClass="fill-primary" icon={props.icon} {...props} />
				<div className={['text-muted', styles.text].join(' ')}>{props.text}</div>
			</Nav.Link>
		</Col>
	);
};

export default AppLink;
